import React from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import CoreServices from "./CoreServices";
import Faq from "./Faq";
import HeroBanner from "../HeroBanner";
import PartnerWithUs from "./PartnerWithUs";
import WhyChooseUs from "./WhyChooseUs";
import QuickContact from "./QuickContact";
import Testimonial from "./Testimonial";

const Home = () => {
  return (
    <>
      <Header />

      <div className="body-overlay"></div>

      <main>
        {/* ===== Banner Area ===== */}
        <HeroBanner />
        <CoreServices />
        {/* <PartnerWithUs />*/}
        <WhyChooseUs />
        {/* <Faq />  */}
        <Testimonial />
        <QuickContact />
      </main>
      <Footer />
    </>
  );
};

export default Home;
